export default __webpack_public_path__ + "static/media/Verbotics.c79543cc.png";